export enum TutorialKeys {
  People = 'hasSeenPeopleTutorial',
  Organization = 'hasSeenOrganizationTutorial',
  Aspect = 'hasSeenAspectTutorial',
  First = 'hasSeenFirstTutorial',
  SurveysSoftSkill = 'hasSeenSurveysTutorialSoftSkill',
  SurveysHardSkills = 'hasSeenSurveysTutorialHardSkills',
  Departments = 'hasSeenDepartmentsTutorial',
  Employee = 'hasSeenEmployeeTutorial',
  Manager = 'hasSeenManagerTutorial',
  ManagerTeam = 'hasSeenManagerTeamTutorial',
  ManagerDepartment = 'hasSeenManagerDepartmentTutorial',
  Assessment = 'hasSeenTutorialAssessment',
  SoftSkills = 'hasSeenSoftSkillsTutorial',
  TrainingHardSkillsLearning = 'hasSeenTrainingHardSkillsLearningTutorial',
  TrainingHardSkillsAdmin = 'hasSeenTrainingHardSkillsAdminTutorial',
  TrainingSoftSkillsLearning = 'hasSeenTrainingSoftSkillsLearningTutorial',
  TrainingSoftSkillsAdmin = 'hasSeenTrainingSoftSkillsAdminTutorial',
  ReportsAssessments = 'hasSeenReportsAssessmentsTutorial',
  ReportsTrainings = 'hasSeenReportsTrainingsTutorial',
  Settings = 'hasSeenSettingsTutorial',
}
